/**
 * Compact tracking for public article URLs (?x=...) so "Finished" works when
 * ?d=&m=&r= is stripped by SMS clients or users copy only the path.
 * Payload: JSON { d, m, r } base64url-encoded (ASCII-safe IDs).
 */

function normalizeTrackingValue(v) {
  if (v == null) return null;
  const t = String(v).trim();
  return t ? t : null;
}

export function encodeArticleTrackingPack(discipleId, mentorAppID, resourceId) {
  const d = normalizeTrackingValue(discipleId);
  const m = normalizeTrackingValue(mentorAppID);
  const r = normalizeTrackingValue(resourceId);
  if (!d || !m || !r) return '';
  const json = JSON.stringify({ d, m, r });
  return btoa(json).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/**
 * @param {string} encoded
 * @returns {{ discipleId: string, mentorAppID: string, resourceId: string } | null}
 */
export function decodeArticleTrackingPack(encoded) {
  if (!encoded || typeof encoded !== 'string') return null;
  try {
    let base64 = decodeURIComponent(encoded.trim());
    base64 = base64.replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;
    if (pad) base64 += '='.repeat(4 - pad);
    const o = JSON.parse(atob(base64));
    const discipleId = normalizeTrackingValue(o.d);
    const mentorAppID = normalizeTrackingValue(o.m);
    const resourceId = normalizeTrackingValue(o.r);
    if (!discipleId || !mentorAppID || !resourceId) return null;
    return { discipleId, mentorAppID, resourceId };
  } catch (_) {
    return null;
  }
}
